import React, {useContext, useEffect, useState} from 'react';
import { Field } from 'react-final-form';
import MuiButton from "@material-ui/core/Button";
import styled from "styled-components";
import {usePage} from "@inertiajs/inertia-react";

import RadioButton from './RadioBig';
import Grid from "@material-ui/core/Grid";
import Select from "./Select";
import TextInput from "./TextInput";
import SelectCard from "./SelectCard";
import {getCookieValue} from "../utils/getCookieValue";

import { Trans } from "../utils/i18n";
import {Alert} from "@material-ui/lab";
import {useFormState, useFormStateDispatch} from "../FormComponents/FormState";

const MarginTop = styled.div`
  margin-top: 15px;
`;

const SerialNumberReturnService = React.memo(function ({ values, form }) {
    const [error, setError] = useState(false);
    const formState = useFormState();
    const formStateDispatch = useFormStateDispatch();
    const { orderPrefilled } = usePage().props;

    const onEnter = (event) => {
        if(!values.ordernumber || !values.email) {
            return;
        }

        fetch(route('returnservice.verify'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN'),
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
                ordernumber: values.ordernumber,
                email: values.email,
            })
        })
            .then(response => response.json())
            .then(data => {
                if(!data.success || !data.order) {
                    throw data.message;
                }
                form.change('street', data.address?.street)
                form.change('zip', data.address?.zip)
                form.change('city', data.address?.city)
                form.change('address1', data.address?.name)
                form.change('country_id', data.address?.country_id)
                form.change('phone', data.address?.phone)

                formStateDispatch({ type: 'setOrder', value: data.order });
                formStateDispatch({ type: 'emailConfirmed' });
                setError(false);
            })
            .catch((errorMessage) => {
                // returnServiceDispatch({ type: 'setOrder', value: null });
                setError(errorMessage);
            })
        event.preventDefault();
    };

    return (
        <div>
            <Grid container spacing={3}>
                <Grid item xs={10} sm={8}>
                    <Field
                        name={'ordernumber'}
                        type={'text'}
                        component={TextInput}
                        validate={value => (value ? undefined : <Trans i18nKey="common.required">Required</Trans>)}
                        field={{
                            label: <Trans i18nKey="returnService.ordernumber">Job number or Serial number</Trans>,
                        }}
                        onEnter={onEnter}
                        disabled={orderPrefilled}
                    />
                    <MarginTop>
                        <Field
                            name={'email'}
                            type={'text'}
                            component={TextInput}
                            validate={value => (value ? undefined : <Trans i18nKey="common.required">Required</Trans>)}
                            field={{
                                label: <Trans i18nKey="email">E-Mail</Trans>,
                            }}
                            onEnter={onEnter}
                            disabled={formState.emailConfirmed}
                        />
                    </MarginTop>
                </Grid>
                <Grid item xs={10} sm={4}>
                    { !formState.emailConfirmed && <MuiButton
                        variant="contained"
                        color={'secondary'}
                        onClick={onEnter}
                        style={{width: '100%', marginTop: 72}}
                    >
                        <Trans i18nKey="common.search">Search</Trans>
                    </MuiButton>}
                </Grid>
            </Grid>
            {
                error && <div style={{ marginTop: 30 }}>
                    <Alert severity="error">{ error }</Alert>
                </div>
            }
        </div>
    );
},
function areEqual(prevProps, nextProps) {
    return JSON.stringify(prevProps) === JSON.stringify(nextProps);
});

export default SerialNumberReturnService;
